import { Alert, App, Button, Card, Flex, Form, Input, Modal, Radio, Select, Table, TablePaginationConfig, Tag, Typography } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { CommitteeList } from "../../model/CommitteeList";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { FacilityInterface } from "../../model/IResearcher";
import { InsiderList } from "../../model/InsiderList";
import { CommitteeProject } from "../../model/IprojectInfo";
import LoadingOverlay from 'react-loading-overlay-ts';
import { ExclamationCircleOutlined , CrownOutlined} from "@ant-design/icons";

const { Title, Text } = Typography;


export function CommitteeListManage(){
    const [isActive,setisActive]= useState(false);
    const [StatusMod,setStatusMod] = useState(false)
    const [PresMod,setPresMod] = useState(false)


    const {notification} = App.useApp();

    const navigate = useNavigate();

    const [OutsiderForm] = Form.useForm();
    

    const [changeOutsiderInfoMod,setChangeOutsiderInfoMod] = useState(false)

    const [currentcommittee,setcurrentcommittee] = useState('')
    
    const [CommitteeList,setCommitteeList] = useState<CommitteeList[]>([]);
    const [CommitteeSubmittedList,setCommitteeSubmittedList] = useState <CommitteeList[]>([])
    const [CommitteeSummarList,setCommitteeSummaryList] = useState<CommitteeProject[]>([])
    const [FacList,setFacList] = useState<FacilityInterface[]>([]);
    const [FacMemberList,setFacMemberList] = useState<InsiderList[]>([]);
    const [newCommittee] = Form.useForm();
    const [CommitteeUser,setCommitteeUser] = useState('');
    const isInsider = Form.useWatch('isInsider', newCommittee);
    const [CommitteeReviewSummary,setCommitteeReviewSummary] = useState(false)
    const [CommitteePagination, setCommitteePagination] = useState<{
        current: number;
        pageSize: number;
      }>({
        current: 1,
        pageSize: 10,
      });

      const isInsiderOrNot = Form.useWatch('isInsider', newCommittee);
    

    const getList = async()=>{
        await axios.get(`${process.env.REACT_APP_BASE}/GetCommitteeList`).then((response)=>{
            if(response.status==200){
                console.log(response.data)
                setCommitteeList(response.data)
            }
        })
        await axios.get(`${process.env.REACT_APP_BASE}/ReviewList`).then((response)=>{
            if(response.status==200){
                setCommitteeSummaryList(response.data)
                setCommitteeSubmittedList(
                    response.data.filter(
                      (item: any, index: number, self: any[]) =>
                        index === self.findIndex((t) => t.CommitteeName === item.CommitteeName)
                    )
                  );
            }
        })
    }

    const getFacList = async() =>{
        await axios.get(`${process.env.REACT_APP_API}/select_faculty.php`).then((response)=>{
            if(response.status==200){
                setFacList(response.data)
            }
        }) 
    }

    const getFacstaff = async(facid:any) =>{
        await axios.get(`${process.env.REACT_APP_API}/select_fac_worker.php?facid=${facid}`).then((response)=>{
            if(response.status==200){
                setFacMemberList(response.data)
            }
        }) 
    }

    const AddNewCommittee = async()=>{
        setisActive(true)
        const Formdata = newCommittee.getFieldsValue();
        const data = { 
            isInsider:Formdata.isInsider,
            CommitteeName:Formdata.CommitteeName,
            email:Formdata.email,
            userID:CommitteeUser,
            password:Formdata.password,
            AddBy:sessionStorage.getItem('user')}
        try {
                const response = await axios.post(`${process.env.REACT_APP_BASE}/AddNewCommittee`, data);
                if (response.status === 200) {
                    window.location.reload();
                }
        } catch (error: any) {
                setisActive(false)

                notification.error({
                    message: 'เพิ่มกรรมการไม่สำเร็จ',
                    description: error.response?.data?.error || 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ',
                });
        }
    }

    const ChangeOutsiderInfo = async()=>{
        const NewInfo = OutsiderForm.getFieldsValue();

        const data ={
            CommitteeName:NewInfo.CommitteeName,
            email:NewInfo.email,
            password:NewInfo.password,
            userID:currentcommittee,
        }

        await axios.post(`${process.env.REACT_APP_BASE}/EditCommitteeInfo`,data).then(response=>{
            if(response.status==200){
                window.location.reload();
            }
        })
    }

    const handleChangeStatus  = async()=> {
        const data ={
            Committee_id: currentcommittee
        }
        await axios.post(`${process.env.REACT_APP_BASE}/ChangeCommitteeStatus`,data).then((response)=>{
            if(response.status==200){
                window.location.reload();
            }
        })
    }

    const handlePresStatus  = async()=> {
        const data ={
            presidentID: currentcommittee
        }
        await axios.post(`${process.env.REACT_APP_BASE}/ChangePresStatus`,data).then((response)=>{
            if(response.status==200){
                sessionStorage.clear();
                window.location.reload();
            }
        })
    }

  
    useEffect(() => {
            getList();
            getFacList();
            
    }, []);
    return(<>
    <LoadingOverlay
            active={isActive}
            spinner
            text='กำลังโหลดข้อมูล'
        >
        <Flex justify='space-between'>
            <h1>รายชื่อกรรมการที่มีในระบบ</h1>
            <h1><Button onClick={()=>setCommitteeReviewSummary(true)}>ดูสรุปการพิจารณาของกรรมการแต่ละท่าน</Button></h1>
        </Flex>
        <Modal
            open={CommitteeReviewSummary}
            onCancel={()=>setCommitteeReviewSummary(false)}
            width={'70vw'}
            footer={<></>}>
            <h2>รวมผลสรุปข้อมูล</h2>
            <hr/>
            <Table columns={[
                        {
                            title:'ลำดับ',
                            render: (_: any, record: any,index:any) =>
                                <>
                                <p>{index+1}</p>
                                </>
                        },
                        {
                            title:'รายชื่อกรรมการ',
                            dataIndex:'CommitteeName'
                        },
                        {
                            title: 'รายชื่อโครงการที่พิจารณา',
                            render: (_: any, record: any) => (
                              <>
                                {CommitteeSummarList
                                  .filter((item) => item.CommitteeName === record.CommitteeName) // ✅ show only projects of this committee
                                  .map((item, index) => (
                                    <p key={index}>
                                      {index + 1}. {item.project_nameTH} ({item.project_nameEN}) โดย {item.researcher_THname}({item.researcher_ENname})
                                    </p>
                                  ))}
                              </>
                            ),
                          },
                        {
                            title:'จำนวนโครงการที่พิจารณา(ของนักศึกษาปริญญาโท-เอก)',
                            render: (_: any, record: any) => (
                              <>
                                {CommitteeSummarList
                                  .filter((item) => (item.CommitteeName === record.CommitteeName&&(item.education_level=='ปริญญาเอก'||item.education_level=='ปริญญาโท'))) 
                                  .length}
                              </>
                            ),
                        },
                        {
                            title:'จำนวนโครงการที่พิจารณา(ของนักศึกษาปริญญาตรี)',
                            render: (_: any, record: any) => (
                              <>
                                {CommitteeSummarList
                                  .filter((item) => (item.CommitteeName === record.CommitteeName&&(item.education_level=='ปริญญาตรี'))) 
                                  .length}
                              </>
                            ),
                        },
                        {
                            title:'จำนวนโครงการที่พิจารณา(ของอาจารย์/บุคลากรภายใน)',
                            render: (_: any, record: any) => (
                                <>
                                {CommitteeSummarList
                                  .filter((item) => (item.CommitteeName === record.CommitteeName&&(item.posname=='บุคลากร'||item.posname=='อาจารย์'))) 
                                  .length}
                              </>
                            ),
                        },
                        {
                            title:'จำนวนโครงการที่พิจารณาทั้งหมด',
                            render: (_: any, record: any) => (
                                <>
                                {CommitteeSummarList
                                  .filter((item) => (item.CommitteeName === record.CommitteeName)) 
                                  .length}
                                </>
                            ),
                        }
                    ]}
                    scroll={{ x: 'calc(700px + 50%)', y: 47 * 5 }}
                    dataSource={CommitteeSubmittedList}/>
        </Modal>
        <Table
            columns={[
                {
                    title: "ลำดับ",
                    render: (_, __, index) => {
                      const page = CommitteePagination.current;
                      const pageSize = CommitteePagination.pageSize;
                      return (page - 1) * pageSize + index + 1;
                    },
                  },
                  {
                    title: "รายชื่อคณะกรรมการ",
                    dataIndex: "CommitteeName",
                  },
                  {
                    title: "Email",
                    dataIndex: "email",
                  },{
                    title:'สถานะ',
                    dataIndex:"isActive",
                    render: (_,record)=>(
                        <>
                            {record.isActive=='active'&&<Tag color="green">{record.isActive}</Tag>||<Tag color="red">{record.isActive}</Tag>}
                        </>
                    )
                  },
                  {
                    title: "ถูกเพิ่มเมื่อ",
                    dataIndex: "addAt",
                    render: (_, record) => (
                      <>{moment.utc(record.addAt).format("DD/MM/YY HH:mm:ss")}</>
                    ),
                  },
                  {
                    title: "",
                    dataIndex: "action",
                    render: (_, record) => (
                      <>
                      <Flex justify='center'>
                        <Button 
                           
                            onClick={()=>{
                            OutsiderForm.setFieldsValue(
                                {
                                    CommitteeName:record.CommitteeName,
                                    email:record.email,
                                    
                                }
                            )
                            setcurrentcommittee(record.userID)
                            setChangeOutsiderInfoMod(true)}} 
                            disabled={record.isInsider==1}>
                            แก้ไขข้อมูล
                        </Button>
                      </Flex>
                      <br/>
                      <Flex justify='center'>
                      <Button
                        type="primary"
                        disabled={record.isPresident === 'active'}
                        style={{
                            backgroundColor:
                            record.isPresident === 'active' ? '#d9d9d9' : '#52c41a',
                            borderColor:
                            record.isPresident === 'active' ? '#d9d9d9' : '#52c41a',
                            color:
                            record.isPresident === 'active' ? '#8c8c8c' : '#fff',
                            cursor:
                            record.isPresident === 'active' ? 'not-allowed' : 'pointer',
                        }}
                        onClick={() => {
                            setPresMod(true);
                            setcurrentcommittee(record.userID);
                        }}
                        >
                        {record.isPresident === 'active'
                            ? 'เป็นประธานอยู่แล้ว'
                            : 'แต่งตั้งเป็นประธาน'}
                        </Button>
                      </Flex>
                      <br/>
                      <Flex justify='center'>
                      <Button onClick={()=>{
                        setStatusMod(true)
                        setcurrentcommittee(record.userID)
                      }} type='primary'
                      disabled={record.isPresident=='active'}
                      >
                        เปลี่ยนสถานะ
                      </Button>
                      </Flex>
                      </>
                    ),
                  }
            ]}
            dataSource={CommitteeList}
            pagination={{
                ...CommitteePagination,
                total: CommitteeList.length,
              }}
              onChange={(pagination: TablePaginationConfig) => {
                setCommitteePagination({
                  current: pagination.current ?? 1,   // fallback to 1 if undefined
                  pageSize: pagination.pageSize ?? 10, // fallback to 10 if undefined
                });
              }}
            />
            <Modal

                open={PresMod}
                onCancel={() => setPresMod(false)}
                onOk={() => {
                    handlePresStatus();
                }}
                okText="แต่งตั้ง"
                cancelText="ยกเลิก"
                centered
                width={'70vw'}
                >
                  <div style={{ textAlign: "center", padding: "8px 0" }}>
                    <CrownOutlined
                    style={{
                        fontSize: 56,
                        color: "#52c41a",
                        marginBottom: 16,
                    }}
                    />

                    <Typography.Title level={4}>
                    ยืนยันการแต่งตั้งประธาน
                    </Typography.Title>

                    <Typography.Paragraph
                    style={{
                        fontSize: 15,
                        marginBottom: 24,
                    }}
                    >
                    ท่านต้องการแต่งตั้งกรรมการท่านนี้ให้ดำรงตำแหน่ง
                    <strong> ประธานคณะกรรมการ </strong>
                    ใช่หรือไม่
                    </Typography.Paragraph>

                    <Alert
                    type="warning"
                    showIcon
                    message="คำเตือนสำคัญ"
                    description={
                        <>
                        การแต่งตั้งกรรมการท่านนี้เป็นประธาน
                        จะส่งผลให้สิทธิ์การใช้งานในฐานะประธานของท่านสิ้นสุดลงทันที
                        <br />
                        <br />
                        หลังจากยืนยันการดำเนินการ ระบบจะทำการออกจากระบบโดยอัตโนมัติ
                        และท่านจะไม่สามารถเข้าสู่ระบบในฐานะประธานได้อีก
                        จนกว่าจะได้รับการแต่งตั้งให้ดำรงตำแหน่งประธานอีกครั้ง
                        </>
                    }
                    style={{ textAlign: "left" }}
                    />
                </div>
            </Modal>
          <Modal
            open={StatusMod}
            onCancel={() => setStatusMod(false)}
            onOk={handleChangeStatus}
            okText="ยืนยัน"
            cancelText="ยกเลิก"
            centered
            >
            <div style={{ textAlign: "center" }}>
                <ExclamationCircleOutlined
                style={{
                    fontSize: 56,
                    color: "#1677ff",
                    marginBottom: 16,
                }}
                />

                <h2 style={{ marginBottom: 12 }}>
                ยืนยันการเปลี่ยนสถานะ
                </h2>

                <p
                style={{
                    fontSize: 16,
                    color: "#262626",
                    marginBottom: 20,
                }}
                >
                คุณต้องการเปลี่ยนสถานะของกรรมการท่านนี้ใช่หรือไม่
                </p>

                <div
                style={{
                    background: "#f5f5f5",
                    borderRadius: 8,
                    padding: 12,
                    textAlign: "left",
                }}
                >
                <strong>หมายเหตุ</strong>
                <br />
                ท่านสามารถเปลี่ยนสถานะของกรรมการท่านนี้ในภายภาคหน้าได้เสมอ
                </div>
            </div>
            </Modal>
            <Modal open={changeOutsiderInfoMod}
            onCancel={()=>setChangeOutsiderInfoMod(false)}
            footer={<></>}
            title={<><h2>แก้ไขข้อมูลกรรมการภายนอก</h2></>}>
            <Form form={OutsiderForm} layout='vertical'>
                <Form.Item name='CommitteeName' label='ชื่อเต็มรวมคำนำหน้าชื่อ'>
                    <Input style={{borderColor:'grey'}}/>
                </Form.Item>
                <Form.Item name='email' label='Email'>
                    <Input/>
                </Form.Item>
                <Form.Item name='password' label='รหัสผ่านใหม่'>
                    <Input placeholder='กรุณากรอกรหัสผ่านใหม่ที่ต้องการเปลี่ยน'/>
                </Form.Item>
                <Button onClick={ChangeOutsiderInfo}>
                    บันทึกข้อมูลที่เปลี่ยนไป
                </Button>
            </Form>
            </Modal>
       
            <h2>เพิ่มกรรมการ</h2>
            <hr/>
            <Flex justify='center'>
                <Card style={{width:'80vw',
                        display: 'flex',    
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',}}> 
                    <Form form={newCommittee} style={{width:'50vw'}}>
                        <Form.Item name='isInsider' label='เป็นบุคลากรภายในหรือไม่'>
                            <Radio.Group
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 8,
                                }}
                                options={[
                                    { value: '1', label: 'ใช่' },
                                    { value: '0', label: 'ไม่' },
                                ]} />
                        </Form.Item>
                        {isInsider==1&&<>
                            <Form.Item label='เลือกสาขาของกรรมการ'>
                                <Select
                                    onChange={(item)=>getFacstaff(item)}
                                    options={
                                        FacList.map((item)=>(
                                            {
                                                value: item.Fac_ID, label:item.Fac_NameTH
                                            }
                                        ))
                                    }/>
                            </Form.Item>
                            <Form.Item name='CommitteeName' label='เลือกชื่อกรรมการ'>
                                <Select
                                    onChange={(value)=>{
                                        const tmpWKID = FacMemberList.filter((item)=>(item.Per_PrefixTH +item.Per_FNameTH+' '+item.Per_LNameTH)==value)
                                        setCommitteeUser(tmpWKID[0].WK_ID)}}
                                    options={
                                        FacMemberList.map((item)=>(
                                            {
                                                value: item.Per_PrefixTH +item.Per_FNameTH+' '+item.Per_LNameTH, label:item.Per_PrefixTH +item.Per_FNameTH+' '+item.Per_LNameTH
                                            }
                                        ))
                                    }/>
                            </Form.Item>
                        </>}
                        {isInsider==0&&
                        <Form.Item name='CommitteeName' label='ชื่อเต็มรวมคำนำหน้าชื่อ'>
                            <Input/>
                        </Form.Item>}
                        <Form.Item name='email' label='email'>
                            <Input/>
                        </Form.Item>
                        {isInsiderOrNot==0&&
                        <Form.Item name='password' label='รหัสผ่าน'>
                            <Input/>
                        </Form.Item>}
                    <Card 
                        style={{
                            display: 'flex',    
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            textAlign: 'left',}}>
                        หมายเหตุ : การเพิ่มบุคคลภายนอกจะเป็นการสร้างบัญชีผู้ใช้ใหม่สำหรับ ระบบยื่นคำขอพิจารณาจริยธรรมวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล
                    </Card>
                    <br/>
                        <Flex justify='end'>
                            <Button onClick={()=>AddNewCommittee()}>เพิ่มกรรมการ</Button>
                        </Flex>
                    </Form>

                </Card>
            </Flex>
            </LoadingOverlay>
    </>)
}

function createStyles(arg0: ({ css, token }: { css: any; token: any; }) => { customTable: any; }) {
    throw new Error("Function not implemented.");
}
